export default "__VITE_ASSET__eeb986ae__"